import { useTranslations } from 'use-intl';
import { Caption } from '@leanin/ui';
import { AuthorAttribution } from '@/components/AuthorAttribution';
import { useFormatDate } from '@/lib/format-date.client';
import type { ResourceDetailView } from '@/lib/queries/resources';

// `author` is null when the server has no showable profile for the author.
// The byline then carries the date alone: nothing derived from
// `authorUserId` may reach the page.
export function AuthorByline({ resource }: { resource: ResourceDetailView }) {
  const fmt = useFormatDate();
  const t = useTranslations('Resources');
  const meta =
    resource.publishedAt !== null
      ? t('detail.publishedAt', { date: fmt.medium(resource.publishedAt) })
      : t('detail.draft');
  const { author } = resource;
  if (author === null) return <Caption>{meta}</Caption>;
  return (
    <AuthorAttribution
      name={`${author.firstName} ${author.lastName}`.trim()}
      userId={author.id}
      {...(author.photoUrl ? { photo: author.photoUrl } : {})}
      {...(author.jobTitle ? { role: author.jobTitle } : {})}
      {...(author.company ? { company: author.company } : {})}
      meta={meta}
      avatarSize={44}
    />
  );
}
